import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { TreeSelect } from 'ant-design-vue';
import moment from 'moment';
import { getActivityDetail, updateActivityDetail } from '@/services/marketing/activity';
// import dateRange from '@/components/DateRange/index.vue'
import fanyiPic from '@/assets/fanyi.png';
import FooterToolBar from '@/components/tool/FooterToolBar';
import TinymceEditor from '@/components/tinymce';
import { upload } from '@/services/common';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  name: 'ActivityInfo',
  i18n: require('./i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    FooterToolBar: FooterToolBar,
    TinymceEditor: TinymceEditor
    // dateRange
  },
  props: {
    activityId: {
      type: Number,
      default: null
    },
    lookinfo: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    var validateActivitytime = function validateActivitytime(rule, value, callback) {
      if (!_this.activityinfoparam.startTime && !_this.activityinfoparam.endTime) {
        callback(new Error(_this.$t('activity.selectactivitytime')));
      } else {
        callback();
      }
    };
    return {
      timeStatus: false,
      //活动时间是否可以编辑状态
      isOrder: false,
      nameErr: this.$t('activity.nameprop'),
      updateLoading: false,
      loading: false,
      imageUrl: '',
      disabledareaList: [],
      fanyiPic: fanyiPic,
      oneshowFY: true,
      threehowFY: false,
      twoshowFY: false,
      SHOW_PARENT: SHOW_PARENT,
      rules: {
        activitystarttime: [{
          required: true,
          validator: validateActivitytime,
          trigger: 'change'
        }],
        disabledarea: [{
          required: true,
          message: this.$t('activity.zoneofactionprop'),
          trigger: 'change'
        }],
        repeattimes: [{
          required: true,
          message: this.$t('activity.repeattimesprop'),
          trigger: 'blur'
        }]
      },
      activitystarttime: '',
      activityendtime: '',
      activityinfoparam: {
        //活动类型名称
        activityTypeName: '',
        multilingualList: [],
        timeArry: [],
        startTime: '',
        endTime: '',
        descList: []
      },
      activityLangList: [],
      tabKey: '0'
    };
  },
  watch: {
    'activityinfoparam.startTime': function activityinfoparamStartTime() {
      if (this.activityinfoparam.startTime && this.activityinfoparam.endTime) {
        this.$refs.ruleForm.clearValidate("activitystarttime");
      }
    }
  },
  created: function created() {
    this.getActivityInfo();
  },
  activated: function activated() {
    this.getActivityInfo();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      var self = this;
      self.tabKey = activeKey;
    },
    /* 控制不能选择当前时间之前的数据 */disabledDate: function disabledDate(current) {
      return moment(current).format('YYYY-MM-DD HH') < moment(new Date()).format('YYYY-MM-DD HH');
    },
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      self.activityLangList = [];
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('activity.name') + '(' + item.langName + ')';
          nameObj.descName = item.langName;
          //多语言id
          nameObj.langId = item.langId;
          //活动名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
            self.tabKey = item.langId;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          self.activityLangList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    getActivityInfo: function getActivityInfo() {
      var _this2 = this;
      getActivityDetail(this.activityId).then(function (response) {
        var activityData = response.data.data;
        if (activityData != null) {
          //获取系统中的多语言
          _this2.getInitialValue();
          //1:单品打折 2:单品积分翻倍 3:单品特价 4:满减活动 5:满折活动
          // if (activityData.activityType == 1) {
          // 	this.activityinfoparam.activityTypeName = this.$t('activity.unitdiscount')
          // } else if (activityData.activityType == 2) {
          // 	this.activityinfoparam.activityTypeName = this.$t('activity.doublepoints')
          // } else if (activityData.activityType == 3) {
          // 	this.activityinfoparam.activityTypeName = this.$t('activity.specialoffer')
          // } else if (activityData.activityType == 4) {
          // 	this.activityinfoparam.activityTypeName = this.$t('activity.fullreduction')
          // } else {
          // 	this.activityinfoparam.activityTypeName = this.$t('activity.fulldiscount')
          // }
          var dataList = activityData.nameList;
          var langList = _.cloneDeep(_this2.activityLangList);
          var _iterator2 = _createForOfIteratorHelper(langList),
            _step2;
          try {
            var _loop = function _loop() {
              var langObj = _step2.value;
              var findObj = _.find(dataList, function (o) {
                return o.langId == langObj.langId;
              });
              if (findObj) {
                langObj.id = findObj.id;
                langObj.name = findObj.name;
              }
            };
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
            //多语言名称
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          console.log(langList, 'lang...........................');
          _this2.activityinfoparam.multilingualList = _.cloneDeep(langList);
          _this2.activityinfoparam.startTime = activityData.startTime;
          _this2.activityinfoparam.endTime = activityData.endTime;
          _this2.activityinfoparam.timeArry.push(activityData.startTime);
          _this2.activityinfoparam.timeArry.push(activityData.endTime);
          _this2.activityinfoparam.descList = [];
          langList.forEach(function (item1) {
            var obj = {
              langId: item1.langId,
              name: item1.descName,
              desc: ''
            };
            if (activityData.descList instanceof Array) {
              console.log('8888888888........');
              activityData.descList.forEach(function (item2) {
                if (item1.langId == item2.langId) {
                  console.log('1246578........');
                  obj.desc = item2.desc;
                  console.log(obj);
                }
              });
            }
            _this2.activityinfoparam.descList.push(obj);
          });
          console.log(_this2.activityinfoparam.descList, '1111111111111111111111');
          // if(activityData.previewUrl){
          // this.activityinfoparam.previewUrl = activityData.previewUrl+'?activityId='+activityData.id;	
          // }

          if (activityData.activityStatus > 0) {
            _this2.timeStatus = true;
          }
          if (activityData.isOrder == 1) {
            _this2.isOrder = true;
          }
        }
      });
    },
    onChange: function onChange(value, dateString) {
      this.activityinfoparam.startTime = value[0];
      this.activityinfoparam.endTime = value[1];
    },
    onOk: function onOk(value) {},
    saveActivity: function saveActivity() {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        var newdescList = _this3.activityinfoparam.descList.map(function (item) {
          return {
            langId: item.langId,
            desc: item.desc
          };
        });
        if (valid) {
          var updateData = {
            id: _this3.activityId,
            startTime: _this3.activityinfoparam.startTime,
            endTime: _this3.activityinfoparam.endTime,
            descList: newdescList,
            nameList: _this3.activityinfoparam.multilingualList
          };
          console.log(updateData);
          _this3.updateLoading = true;
          updateActivityDetail(updateData).then(function (response) {
            // console.log(response)
            if (response.data.code == 200) {
              _this3.$message.success(_this3.$t('public.updateSuccessfully'));
              _this3.getActivityInfo();
            }
            _this3.updateLoading = false;
          }).finally(function () {
            _this3.updateLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    showFYBtn: function showFYBtn(activityNameObj) {
      // let self = this;
      // let couponNameObjClone = self.couponinfoparam.multilingualList;
      // for (let one of couponNameObjClone) {
      // 	one.showNameFY = false;
      // }
      // self.couponinfoparam.multilingualList = couponNameObjClone;
      // couponNameObj.showNameFY = true;
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('type', 6);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    }
  }
};